module.exports = __webpack_public_path__ + "public/SiteIcons/reviewSearch.svg?84c4d27b";